// src/components/AboutSection.jsx
import React from "react";
import "./Overview.css"; // re-use your dashboard theme vars + card styles

const AboutSection = () => {
  return (
    <div className="overview">
      {/* Hero / summary banner */}
      <div className="summary-card market-tone">
        <h3>About</h3>
        <p>
          Market Intelligence Dashboard is a lightweight snapshot of macro + market risk conditions.
          It brings key indicators into one place so you can quickly answer: is the market calm,
          stressed, or shifting?
        </p>
      </div>

      <section className="overview-block">
        <div className="block-header">
          <div>
            <h2>How to use this dashboard</h2>
            <p>Fast workflow to read the market in under a minute.</p>
          </div>
        </div>

        {/* 2-column grid (responsive) */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
            gap: 16,
          }}
        >
          <div className="chart-card">
            <div className="chart-title">Quick workflow</div>
            <div style={{ marginTop: 10, color: "var(--text-secondary)", lineHeight: 1.6 }}>
              <div>
                <b style={{ color: "var(--text-primary)" }}>Market Overview:</b> big picture (rates,
                inflation, growth signals).
              </div>
              <div>
                <b style={{ color: "var(--text-primary)" }}>Sentiment &amp; Risk:</b> volatility,
                credit spreads, yield curve, USD strength.
              </div>
              <div>
                <b style={{ color: "var(--text-primary)" }}>Macro Events &amp; Earnings:</b> what’s
                coming next that can move markets.
              </div>
          </div>
        </div>
        
          <div className="chart-card">
            <div className="chart-title">Quick glossary</div>
            <div style={{ marginTop: 10, color: "var(--text-secondary)", lineHeight: 1.6 }}>
              <div>
                <b style={{ color: "var(--text-primary)" }}>VIX:</b> expected S&amp;P 500 volatility
                (higher = more uncertainty).
              </div>
              <div>
                <b style={{ color: "var(--text-primary)" }}>HY / IG spreads:</b> credit stress (wider
                = higher risk premium).
              </div>
              <div>
                <b style={{ color: "var(--text-primary)" }}>Financial Stress:</b> overall strain in
                financial conditions.
              </div>
              <div>
                <b style={{ color: "var(--text-primary)" }}>Yield curve (10Y–3M):</b> inversion can
                signal tight policy + recession risk.
              </div>
              <div>
                <b style={{ color: "var(--text-primary)" }}>Dollar index:</b> strong USD can tighten
                global liquidity.
              </div>
            </div>
          </div>

          <div className="chart-card">
            <div className="chart-title">Data sources &amp; updates</div>
            <div style={{ marginTop: 10, color: "var(--text-secondary)", lineHeight: 1.6 }}>
              <div>
                <b style={{ color: "var(--text-primary)" }}>Sources:</b> FRED, U.S. Treasury
                FiscalData, FMP (earnings).
              </div>
              <div style={{ marginTop: 8 }}>
                <b style={{ color: "var(--text-primary)" }}>Update notes:</b> the UI may refresh often,
                but many economic series update daily/weekly/monthly, so values may not change intraday.
              </div>
              <div style={{ marginTop: 8 }}>
                <b style={{ color: "var(--text-primary)" }}>Revisions:</b> official data can be revised
                later by the original source.
              </div>
            </div>
          </div>

          <div className="chart-card">
            <div className="chart-title">Disclaimer &amp; roadmap</div>
            <div style={{ marginTop: 10, color: "var(--text-secondary)", lineHeight: 1.6 }}>
              <div>
                <b style={{ color: "var(--text-primary)" }}>Disclaimer:</b> for education/research only.
                Not financial advice. Composite scores are simplified summaries.
              </div>

              <div style={{ marginTop: 12, fontWeight: 700, color: "var(--text-primary)" }}>
                Coming soon
              </div>
              <ul style={{ marginTop: 6, lineHeight: 1.6 }}>
                <li>Watchlist + favorites</li>
                <li>Alerts (VIX spike, spreads widening, curve inversion)</li>
                <li>Export / share snapshots</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Footer note box */}
        <div className="fun-fact" style={{ marginTop: 18 }}>
          <div className="fun-fact-inner">
            <h4>Tip</h4>
            <p>
              If you’re unsure what’s driving the market, check which cards are moving most (VIX, HY spreads,
              curve slope, USD). That usually tells you whether the story is “risk”, “rates”, or “growth.”
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutSection;